var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.renderComponent)?_c('Summary',{attrs:{"pageTitle":'ダッシュボード',"showButton":false,"disabledDatePicker":true,"disabledTimePicker":true,"addStyle":'addStyle',"summariesForm":false}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }